import React from "react";
import { useIntl } from "react-intl";
import { CircularProgress } from "@material-ui/core";
import Images from "../../utils/styles/images";
import messages from "./messages";

/**
 * The loading overlay every list page in this dashboard shows while a request is in flight.
 */
export function NavLoading({ text }) {
  return (
    <div className="nav-list-progress">
      <CircularProgress />
      <p className="nav-list-progress-text">{text}</p>
    </div>
  );
}

/**
 * A failed request has to be visible without scrolling to the table, so it is announced here as
 * well as inside the table body. Silence after a failure is what sends an operator hunting for
 * data that was never fetched.
 */
export function NavErrorBanner({ message, onRetry }) {
  const intl = useIntl();

  if (!message) {
    return null;
  }

  return (
    <div className="nav-error-banner">
      <img src={Images.error} alt="request-failed" />
      <div className="nav-error-banner-text">
        <p className="nav-error-banner-header">
          {intl.formatMessage(messages.errorHeader)}
        </p>
        <p className="nav-error-banner-body">{message}</p>
      </div>
      {onRetry ? (
        <button className="nav-retry-button" onClick={onRetry}>
          {intl.formatMessage(messages.buttonRetry)}
        </button>
      ) : null}
    </div>
  );
}
